export var ItemOperation;
(function (ItemOperation) {
    ItemOperation[ItemOperation["None"] = 0] = "None";
    ItemOperation[ItemOperation["Added"] = 1] = "Added";
    ItemOperation[ItemOperation["Updated"] = 2] = "Updated";
    ItemOperation[ItemOperation["Deleted"] = 3] = "Deleted";
})(ItemOperation || (ItemOperation = {}));
/**
 * Types of changes for tiles.
 * What each change means depends on specific scenario.
 */
export var ItemChanges;
(function (ItemChanges) {
    /**
     * TextTile: Content of tile has changed.
     */
    ItemChanges[ItemChanges["ContentChanged"] = 0] = "ContentChanged";
    /**
     * TextTile: Content was previously empty (null, undefined, only white spaces).
     */
    ItemChanges[ItemChanges["ContentWasEmpty"] = 1] = "ContentWasEmpty";
    /**
     * FormattedTextTile: Formatting has changed.
     */
    ItemChanges[ItemChanges["FormattingChanged"] = 2] = "FormattingChanged";
    /**
     * FormattedTextTile: Content was previously inside of the table or table of contents.
     */
    ItemChanges[ItemChanges["ContentWasInsideOfTheTable"] = 3] = "ContentWasInsideOfTheTable";
})(ItemChanges || (ItemChanges = {}));
export var OperationErrorCode;
(function (OperationErrorCode) {
    OperationErrorCode[OperationErrorCode["AddOfZeroElements"] = 0] = "AddOfZeroElements";
    OperationErrorCode[OperationErrorCode["AddOfItemsWithExtraOrMissingIds"] = 1] = "AddOfItemsWithExtraOrMissingIds";
    OperationErrorCode[OperationErrorCode["AddOfItemWithUndefinedId"] = 2] = "AddOfItemWithUndefinedId";
    OperationErrorCode[OperationErrorCode["AddOfUndefinedItem"] = 3] = "AddOfUndefinedItem";
    OperationErrorCode[OperationErrorCode["AddOfItemsWithDuplicateIds"] = 4] = "AddOfItemsWithDuplicateIds";
    OperationErrorCode[OperationErrorCode["SetHeadToNonExistingItem"] = 5] = "SetHeadToNonExistingItem";
    OperationErrorCode[OperationErrorCode["DeleteOfNonExistingItem"] = 6] = "DeleteOfNonExistingItem";
    OperationErrorCode[OperationErrorCode["UpdateOfNonExistentItem"] = 7] = "UpdateOfNonExistentItem";
    OperationErrorCode[OperationErrorCode["UpdateOfStubbedItem"] = 8] = "UpdateOfStubbedItem";
    OperationErrorCode[OperationErrorCode["MoveOfNonExistentItem"] = 9] = "MoveOfNonExistentItem";
    OperationErrorCode[OperationErrorCode["UpdateMetaDataOfNonAnnotationType"] = 10] = "UpdateMetaDataOfNonAnnotationType";
    OperationErrorCode[OperationErrorCode["SequentialyInvertedUpdate"] = 11] = "SequentialyInvertedUpdate";
    /**
     * A delta operation is submitted against an item which does not exist.
     */
    OperationErrorCode[OperationErrorCode["DeltaOfNonExistingItem"] = 100] = "DeltaOfNonExistingItem";
})(OperationErrorCode || (OperationErrorCode = {}));
//# sourceMappingURL=operations.js.map